import {mount} from 'svelte';

import I18n from '@js/modules/translations';
import {onPageReady} from '@js/modules/utils';

import Notification from '@js/components/layouts/notification';

import RideShow from '@js/components/ride/RideShow.svelte';

import AnalyticsService from '@js/modules/analyticsService';
import StorageService from '@js/modules/storage';


class RideManager {
    _ride = null;

    _biggerPicture = null;

    _$rideData = document.getElementById('ride-data');

    _$map = document.getElementById('ride-map-component');

    _$heartRate = document.getElementById('ride-heart-rate-component');

    _$images = document.querySelectorAll('#ride-carrousel a');


    /* Public methods
    ******************** */
    constructor() {
        this._ride = JSON.parse(this._$rideData.innerText)?.ride;
    }

    initialize = () => {
        this._saveVisitedRide();

        this._mountComponents();

        this._manageImages();

        this._onExportClick();
    };

    /* Private methods
    ******************** */
    _saveVisitedRide = () => {
        StorageService.saveLocalArray('rides-visited', [this._ride.id], true, true);
    };

    _mountComponents = () => {
        mount(RideShow, {
            target: this._$map,
            props: {ride: this._ride}
        });

        if (this._$heartRate) {
            onPageReady(() => {
                import('@js/components/maps/HeartRateGraph.svelte')
                    .then(({default: HeartRateGraph}) => {
                        mount(HeartRateGraph, {
                            target: this._$heartRate,
                            props: {ride: this._ride}
                        });
                    });
            });
        }
    };

    _openImage = (event) => {
        event.preventDefault();

        this._biggerPicture.open({
            items: this._$images,
            el: event.currentTarget,
            scale: 0.85,
            maxZoom: 1
        });
    };

    _manageImages = () => {
        onPageReady(() => {
            import('bigger-picture')
                .then(({default: BiggerPicture}) => {
                    import('bigger-picture/css');

                    this._biggerPicture = BiggerPicture({
                        target: document.body
                    });

                    this._$images.forEach(($image) => $image.addEventListener('click', this._openImage));
                });
        });
    };

    _onExportClick = () => {
        const $exportButton = document.getElementById('export-gpx');
        if (!$exportButton) {
            return;
        }

        $exportButton.onclick = () => {
            AnalyticsService.trackRouteExported(this._ride.id, this._ride.name);

            Notification.info(I18n.t('js.ride.map.export_gpx_progress'));
        };
    };
}

export default new RideManager();
